@if (hasNews()) {
  <app-links-section
    [contentType]="E_CONTENT_TYPE.News"
    [links]="pageData()?.relatedNews"
    [relatedId]="pageData()?.id"
    [title]="'Related news'"></app-links-section>
}
@if (hasPublication()) {
  <app-links-section
    [contentType]="E_CONTENT_TYPE.Publications"
    [links]="pageData()?.relatedPublications"
    [relatedId]="pageData()?.id"
    [title]="'Related publications'"></app-links-section>
}


@if (showDiscussions()) {
  <app-links-section
    [links]="pageData()?.relatedDiscussions"
    [title]="'Related discussions'"></app-links-section>
}

<app-links-section
  [contentType]="E_CONTENT_TYPE.ImportantDates"
  [links]="pageData()?.relatedDates"
  [relatedId]="pageData()?.id"
  [title]="'Related dates'"></app-links-section>
